// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  kind: __t.string(),
  state: __t.string(),
  announceAtMicros: __t.i64().name("announce_at_micros"),
  firesAtMicros: __t.i64().name("fires_at_micros"),
  lastFiredMicros: __t.i64().name("last_fired_micros"),
});
